// extracted by mini-css-extract-plugin
export default {"task-incoming-toggle":"task-incoming-toggle_task-incoming-toggle__8nUoi","task-incoming-toggle-selected":"task-incoming-toggle_task-incoming-toggle-selected__H9qZ4"};